/**
 * Cancellation Application Fields
 * Common fields for ACA and AA licence cancellation
 */

import { RuleProps } from "types/application";

export const SECT_CANCELLATION_DETAILS = 'cancellation-details';

export const CANCELLATION_FIELDS = [
    {
        sectionID: SECT_CANCELLATION_DETAILS,
        sectionName: 'Cancellation Details',
        fieldList: [
            {
                id: 'uen-no',
                label: 'UEN',
                type: 'text',
                span: 6,
                rule: {
                    required: true,
                    disabled: true
                }
            },
            {
                id: 'licence-no',
                label: 'Licence No',
                type: 'text',
                span: 6,
                rule: {
                    required: true,
                    disabled: true
                }
            },
            {
                id: 'effective-date',
                label: 'Effective Date of Cancellation',
                type: 'date',
                span: 12,
                rule: {
                    required: true,
                    errorMsg: 'Effective Date of Cancellation is required',
                    customValidate: ({ currentValue }: any) => {
                        if (!currentValue) return 'Effective Date of Cancellation is required';
                        const today = new Date();
                        const selected = new Date(currentValue);
                        const todayYMD = new Date(today.getFullYear(), today.getMonth(), today.getDate());
                        if (selected < todayYMD) return 'Past date is not allowed';
                        return true;
                    }
                }
            },
            {
                id: 'cancellation-reason',
                label: 'Cancellation Reason',
                type: 'dropdown',
                apiID: 'LICCancelReason',
                span: 12,
                options: [],
                rule: {
                    required: true,
                    errorMsg: 'Cancellation Reason is required'
                }
            },
            {
                id: 'others-reason',
                label: 'If Others, Please Specify',
                type: 'text',
                span: 12,
                rule: {
                    baseIds: [`${SECT_CANCELLATION_DETAILS}-cancellation-reason`],
                    required: ({ baseValues }: RuleProps) => {
                        const result = Boolean(baseValues && baseValues[`${SECT_CANCELLATION_DETAILS}-cancellation-reason`] === 'LCR4');
                        return result;
                    },
                    hidden: ({ baseValues }: RuleProps) => {
                        const result = Boolean(baseValues && baseValues[`${SECT_CANCELLATION_DETAILS}-cancellation-reason`] !== 'LCR4');
                        return result;
                    }
                }
            },
            {
                id: 'remarks',
                label: 'Remarks',
                type: 'longText',
                span: 12,
                rule: {
                    required: false
                }
            }
        ]
    }
];

// AA-specific cancellation fields with different API for cancel reasons
export const CANCELLATION_FIELDS_AA = [
    {
        sectionID: SECT_CANCELLATION_DETAILS,
        sectionName: 'Cancellation Details',
        fieldList: [
            {
                id: 'uen-no',
                label: 'UEN',
                type: 'text',
                span: 6,
                rule: {
                    required: true,
                    disabled: true
                }
            },
            {
                id: 'licence-no',
                label: 'Licence No',
                type: 'text',
                span: 6,
                rule: {
                    required: true,
                    disabled: true
                }
            },
            {
                id: 'effective-date',
                label: 'Effective Date of Cancellation',
                type: 'date',
                span: 12,
                rule: {
                    required: true,
                    errorMsg: 'Effective Date of Cancellation is required',
                    customValidate: ({ currentValue }: any) => {
                        if (!currentValue) return 'Effective Date of Cancellation is required';
                        const today = new Date();
                        const selected = new Date(currentValue);
                        const todayYMD = new Date(today.getFullYear(), today.getMonth(), today.getDate());
                        if (selected < todayYMD) return 'Past date is not allowed';
                        return true;
                    }
                }
            },
            {
                id: 'cancellation-reason',
                label: 'Cancellation Reason',
                type: 'dropdown',
                apiID: 'LICCancelReasonAA',
                span: 12,
                options: [],
                rule: {
                    required: true,
                    errorMsg: 'Cancellation Reason is required'
                }
            },
            {
                id: 'others-reason',
                label: 'If Others, Please Specify',
                type: 'text',
                span: 12,
                rule: {
                    baseIds: [`${SECT_CANCELLATION_DETAILS}-cancellation-reason`],
                    required: ({ baseValues }: RuleProps) => {
                        const result = Boolean(baseValues && baseValues[`${SECT_CANCELLATION_DETAILS}-cancellation-reason`] === 'LCR18');
                        return result;
                    },
                    hidden: ({ baseValues }: RuleProps) => {
                        const result = Boolean(baseValues && baseValues[`${SECT_CANCELLATION_DETAILS}-cancellation-reason`] !== 'LCR18');
                        return result;
                    }
                }
            },
            {
                id: 'remarks',
                label: 'Remarks',
                type: 'longText',
                span: 12,
                rule: {
                    required: false
                }
            }
        ]
    }
];
